/**
 * Chunk/Asset Mismatch Detector (runs in DEV and PROD).
 * Listens to window error + unhandledrejection and records chunk-load failures
 * into bootDebugStore. ChunkErrorFallback shows full-screen "Có lỗi khi tải tài nguyên" + reload.
 */
import { useEffect } from 'react';
import { reportChunkError } from '@/lib/bootDebugStore';

function isChunkErrorMessage(msg: string): boolean {
  return (
    msg.includes('Loading chunk') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Unexpected token <')
  );
}

export function BootDebugInit() {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      const msg = event.message ?? event.reason?.message ?? String(event.reason ?? '');
      if (isChunkErrorMessage(msg)) {
        reportChunkError(msg);
      }
    };

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      const msg =
        (event.reason?.message ?? event.reason?.stack ?? String(event.reason ?? '')).slice(0, 500) || '';
      if (isChunkErrorMessage(msg)) {
        reportChunkError(msg);
      }
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onUnhandledRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onUnhandledRejection);
    };
  }, []);

  return null;
}
